import { MrModalDialog } from '@mrhenry/wp--mr-interactive';
import { MrVideo } from './mr-video';

class MrVideoOverlay extends MrModalDialog {
	videosAlreadyPlaying: MrVideo[] = [];

	override async willOpen() {
		await super.willOpen();
		document.body.classList.add( 'is-showing-modal-dialog' );
		document.documentElement.classList.add( 'is-showing-modal-dialog' );

		const mrVideo = this.querySelector<MrVideo>( 'mr-video' );
		if ( !mrVideo ) {
			return;
		}

		const allVideos = document.querySelectorAll<MrVideo>( 'mr-video' );
		allVideos.forEach( ( video ) => {
			if ( video !== mrVideo ) {
				const videoElement = video.querySelector( 'video' );
				if ( videoElement && !videoElement.paused ) {
					this.videosAlreadyPlaying.push( video );
					video.pause();
				}
			}
		} );

		mrVideo.setupVideoPlayback();
	}

	override async didOpen(): Promise<void> {
		await super.didOpen();

		const mrVideo = this.querySelector<MrVideo>( 'mr-video' );
		if ( !mrVideo ) {
			return;
		}

		await mrVideo.play();
	}

	override async willClose() {
		const mrVideo = this.querySelector<MrVideo>( 'mr-video' );
		if ( !mrVideo ) {
			return;
		}

		await mrVideo.pause();
		await super.willClose();
		document.body.classList.remove( 'is-showing-modal-dialog' );
		document.documentElement.classList.remove( 'is-showing-modal-dialog' );

		this.videosAlreadyPlaying.forEach( ( video ) => {
			video.play();
		} );

		this.videosAlreadyPlaying = [];
	}

	override openAnimations() {
		if ( !( 'KeyframeEffect' in window ) ) {
			return [];
		}

		return [
			new KeyframeEffect(
				this,
				[
					{
						opacity: 0,
					},
					{
						opacity: 1,
					},
				],
				{
					duration: 256,
					easing: 'linear',
					fill: 'forwards',
				}
			),
			new KeyframeEffect(
				this.querySelector( '.modal-dialog__content' ),
				[
					{
						opacity: 0,
					},
					{
						opacity: 1,
					},
				],
				{
					duration: 256,
					easing: 'linear',
					fill: 'forwards',
				}
			),
		];
	}

	override closeAnimations() {
		if ( !( 'KeyframeEffect' in window ) ) {
			return [];
		}

		return [
			new KeyframeEffect(
				this.querySelector( '.modal-dialog__content' ),
				[
					{
						opacity: 1,
					},
					{
						opacity: 0,
					},
				],
				{
					duration: 192,
					easing: 'linear',
					fill: 'forwards',
				}
			),
			new KeyframeEffect(
				this,
				[
					{
						opacity: 1,
					},
					{
						opacity: 0,
					},
				],
				{
					duration: 192,
					easing: 'linear',
					fill: 'forwards',
				}
			),
		];
	}
}

customElements.define( 'mr-video-overlay', MrVideoOverlay );
